var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "64d79449dc5eef4682623e881694ccf5759fe835"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["marketing-site@roadie"] = {
  id: "64d79449dc5eef4682623e881694ccf5759fe835"
};